import { Box, Typography } from "@mui/material"
import type { FC, ReactNode } from "react"

interface PropertyRowProps {
  label: string
  value: ReactNode | string | null
}

export const PropertyRow: FC<PropertyRowProps> = ({ label, value }) => {
  const displayValue = value ?? "-"

  return (
    <Box className='flex gap-4'>
      <Typography variant='body2' className='min-w-[240px] shrink-0 leading-8 text-gray-900'>
        {label}
      </Typography>
      <Typography variant='body2' className='min-w-0 flex-1 break-all leading-8 text-gray-900'>
        {displayValue}
      </Typography>
    </Box>
  )
}
